(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire07df"];
var parcelRegister = parcelRequire.register;
parcelRegister("bLsGx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $027c61b18d792f8d$export$2e2bcd8739ae039; });
const $027c61b18d792f8d$var$createSnowplowV1TrackerEcommerceEventsHandlers = (input)=>{
    const { appId: appId, retailId: retailId } = input;
    return {
        trackTransaction: (input)=>{
            window.tracker(`addTrans`, input.id, input.affiliateId || (retailId !== null && retailId !== void 0 ? retailId : appId), input.total, input.tax, input.shipping, input.city, input.state, input.country, input.currency);
            input.items.forEach((item)=>{
                window.tracker(`addItem`, input.id, item.sku, item.name, item.category, item.unitPrice, item.quantity, input.currency);
            });
            window.tracker(`trackTrans`);
        },
        trackAddToCart: (input)=>{
            window.tracker("trackAddToCart", input.sku, input.name, input.category, input.unitPrice, input.quantity, input.currency);
        },
        trackRemoveFromCart: (input)=>{
            window.tracker("trackRemoveFromCart", input.sku, input.name, input.category, input.unitPrice, input.quantity, input.currency);
        }
    };
};
var $027c61b18d792f8d$export$2e2bcd8739ae039 = $027c61b18d792f8d$var$createSnowplowV1TrackerEcommerceEventsHandlers;

});

})();
//# sourceMappingURL=ecommerce.d9f4b939.js.map
